import { CommApiInstance } from "Utils/CommApiInstance";

const GameSvcCtntCtxtApi = async (
    gameSvcCd:string|null,
    ctntSno:string|null,
) => {
    return await CommApiInstance.post(`${gameSvcCd}/ctnt/${ctntSno}`,{
        apiBody:{
        },
    })
    .then((Resp) => Resp.data);
}
export default GameSvcCtntCtxtApi;